import {ComputationResult} from './../computation-result';
import {Computation} from './../computation';
import {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.univariate.Kurtosis
 */
export interface Kurtosis extends Computation._UnivariateComputation {
    // PolyJson type
    type: 'kurtosis';
}

export function isKurtosis(toTest: Computation): toTest is Kurtosis { return 'kurtosis' === toTest.type; }

export namespace Kurtosis {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.Kurtosis$KurtosisResult
     */
    export interface KurtosisResult extends _AvailableResult {
        value: number;

        // PolyJson type
        type: 'kurtosis';
    }

    export function isKurtosisResult(toTest: ComputationResult): toTest is KurtosisResult { return 'kurtosis' === toTest.type; }
}